import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { filter, map, Observable, of, Subscription, take } from "rxjs";
import { Alarm } from "src/app/models/api/alarms";
import { InfluxService } from "../../../../services/api/influx.service";
import { JwtService } from "../../../../services/core/jwt.service";
import { SensorManagerService } from "../../../../services/api/sensor-manager.service";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
})
export class NotificationComponent implements OnInit, OnDestroy {
  // countAlarms: Number;
  public openNotification: boolean = false;
  private subscription: Subscription;
  // public alarms: Alarm[] = [];
  alarms$!: Observable<Alarm[]>;
  countAlarms$!: Observable<number>;
  constructor(
    private customerApiService: InfluxService,
    private router: Router,
    public auth: JwtService,
    private sensorManagerService: SensorManagerService
  ) {}

  ngOnInit() {
    const stationCodes = localStorage.getItem("stationCodes");
    if (stationCodes) {
      this.getAlarms();
    } else {
      this.sensorManagerService.loaded$.pipe(take(1)).subscribe(() => {
        this.getAlarms();
      });
      // this.sensorManagerService.loaded$.subscribe(() => {
      //   this.getAlarms();
      // });
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  toggleNotificationMobile() {
    this.openNotification = !this.openNotification;
  }

  getAlarms(): void {
    if (this.auth.hasRole(["customer"])) {
      const stationCodeStr = localStorage.getItem("stationCodes") ?? "";
      const stationCodes = stationCodeStr
        .split("|")
        .map((s) => s.trim())
        .filter(Boolean);
      this.alarms$ = stationCodes.length
        ? this.customerApiService.getStationAlarms(stationCodes)
        : of([]);
    } else {
      this.alarms$ = this.customerApiService.getAllAlarms();
    }
    // derive countAlarms$ from alarms$
    this.countAlarms$ = this.alarms$.pipe(map((alarms) => alarms.length));
  }

  getBadgeClass(lev: number): string {
    switch (lev) {
      case 1:
        return "b-l-critical";
      case 2:
        return "b-l-major";
      case 3:
        return "b-l-minor";
      case 4:
        return "b-l-warning";
      default:
        return "";
    }
  }

  closeAndNavigate() {
    this.router.navigate(["/alarms"]);
  }
}
